import CONSTANTS from './constants.js'
export default {
  ...Object.keys(CONSTANTS.TYPE).reduce((acc, key) => {
    acc[CONSTANTS.TYPE[key]] = undefined
    return acc
  }, {}),
  [CONSTANTS.TYPE.SEARCH_INCLUDED]: CONSTANTS.DEFAULTS[CONSTANTS.TYPE.SEARCH_INCLUDED],
  [CONSTANTS.TYPE.SEARCH_LIMIT]: CONSTANTS.DEFAULTS[CONSTANTS.TYPE.SEARCH_LIMIT],
  [CONSTANTS.TYPE.SEARCH_OFFSET]: CONSTANTS.DEFAULTS[CONSTANTS.TYPE.SEARCH_OFFSET],
  [CONSTANTS.TYPE.SEARCH_PAGE]: CONSTANTS.DEFAULTS[CONSTANTS.TYPE.SEARCH_PAGE],
  // [CONSTANTS.TYPE.ITEM_FILTER_COLOR]: undefined,
  // [CONSTANTS.TYPE.ITEM_WHEEL_SIZE_INCH]: undefined,
  // [CONSTANTS.TYPE.EBIKE_ENGINE_MODEL]: undefined,
  // [CONSTANTS.TYPE.PRODUCT_E_BIKE]: undefined,
  // [CONSTANTS.TYPE.PRODUCT_MAIN_CATEGORY]: undefined,
  // [CONSTANTS.TYPE.PRODUCT_BIDEX_COMMODITY_GROUP]: undefined,
  // [CONSTANTS.TYPE.PRODUCT_VARIANTS_CURRENT]: undefined,
  // [CONSTANTS.TYPE.PRODUCT_VARIANTS_OUTLET]: undefined,
  // [CONSTANTS.TYPE.ITEM_COASTER_BRAKE]: undefined,
  // [CONSTANTS.TYPE.PRODUCT_GEAR_TYPE]: undefined,
  [CONSTANTS.SEARCH_REQUEST]: null, // DCWSUPPORTDS-1950
  [CONSTANTS.SEARCH_SKU]: undefined,
}
